// Lib
import * as Immutable from 'immutable';

// Constants
import * as PALETTE_ACTION_TYPES from './colorComboPaletteActionTypes';

const initialState = Immutable.fromJS({
    currentSuggestedColors: [],
    currentUsedColorCombos: [],
});

export default function swatchPalette(state = initialState, action) {
    switch (action.type) {
        case PALETTE_ACTION_TYPES.SUGGESTED_COLORS_UPDATE:
            return state.set('currentSuggestedColors', action.suggestedColors);
        case PALETTE_ACTION_TYPES.USED_COLOR_COMBOS_UPDATE:
            return state.set('currentUsedColorCombos', action.usedColorCombos);
        case '@@router/LOCATION_CHANGE':
            return state
                .set('currentSuggestedColors', Immutable.List())
                .set('currentUsedColorCombos', Immutable.List());
        default:
            return state;
    }
}
